const EUR = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });

export function formatEur(amount: number): string {
  return EUR.format(amount);
}

export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '–';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '–';
  return date.toLocaleString('de-DE', { dateStyle: 'medium', timeStyle: 'short' });
}
